class ClientWarehouseInsertDialogData {

    /**
     * @type {string}
     */
    supplierId;

    /**
     * @type {string}
     */
    supplierArticleNumber;

    /**
     * @type {string}
     */
    productName;

    /**
     * @type {string}
     */
    productDescription;

    /**
     * @type {string}
     */
    orderUnit;

    /**
     * @type {string}
     */
    contentUnit;

    /**
     * @type {number}
     */
    contentUnitsPerOrderUnit;

    /**
     * @type {number}
     */
    quantity;

    /**
     * @type {number}
     */
    receiptId;

    /**
     * @type {number}
     */
    receiptItemId;

    /**
     * @type {number}
     */
    orderItemId;

    /**
     * @type {number}
     */
    manufacturerName;

    /**
     * @type {number}
     */
    manufacturerArticleNumber;

    /**
     * @type {number}
     */
    articleNumberCustomer;

    constructor(
        supplierId,
        supplierArticleNumber,
        productName,
        productDescription,
        orderUnit,
        contentUnit,
        contentUnitsPerOrderUnit,
        quantity,
        receiptId,
        receiptItemId,
        orderItemId,
        manufacturerName,
        manufacturerArticleNumber,
        articleNumberCustomer
    ) {
        this.supplierId = supplierId;
        this.supplierArticleNumber = supplierArticleNumber;
        this.productName = productName;
        this.productDescription = productDescription;
        this.orderUnit = orderUnit;
        this.contentUnit = contentUnit;
        this.contentUnitsPerOrderUnit = contentUnitsPerOrderUnit;
        this.quantity = quantity;
        this.receiptId = receiptId;
        this.receiptItemId = receiptItemId;
        this.orderItemId = orderItemId;
        this.manufacturerName = manufacturerName;
        this.manufacturerArticleNumber = manufacturerArticleNumber;
        this.articleNumberCustomer = articleNumberCustomer;
    }
}

module.exports.ClientWarehouseInsertDialogData = ClientWarehouseInsertDialogData;